import Joi from "joi";
import { name } from "constant/validation/schemas";

const validationSchema = Joi.object({
  name,
  shared: Joi.boolean()
});

export default validationSchema;
